import React from 'react'
import './style.scss'

const Loader = () => {
    return (
        <div className="trip-loader">
            <div className="trip-loader__dot"></div>
            <div className="trip-loader__dot"></div>
            <div className="trip-loader__dot"></div>
        </div>
    )
}

export default Loader
